module.exports = __webpack_public_path__ + "static/img/kv_message.33d910c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/kv_message.png
// module id = wgVj
// module chunks = 0